import { CurrencyService } from '@lemon/core/service/currency.service'
import { DateService } from '@lemon/core/service/date.service'
import { LaskuSharedService, ReskontraService } from './lasku-shared.service'

import { Lasku, Laskuasetukset, LaskuBase, LaskunumeroTyyppi, LaskuReskontra } from '../../model/lasku'

import { Big } from 'big.js'
import { VahvistettuKorkoService } from '../vahvistettu-korko.service'

export class LaskuKorkoService {
  constructor(
    private dateService: DateService,
    private currencyService: CurrencyService,
    private reskontraService: ReskontraService,
    private vahvistettuKorkoService: VahvistettuKorkoService,
    private laskuSharedService: LaskuSharedService,
  ) {}

  annaOletusViivastyskorkoProsentti(): Promise<Big> {
    // TODO: Eri prosentti yksityiskauppaan / yritysten väliseen?
    return this.annaOletusViivastyskorkoProsenttiNumber().then(prosentti => new Big(prosentti))
  }

  async annaOletusViivastyskorkoProsenttiNumber(): Promise<number> {
    try {
      return this.vahvistettuKorkoService.annaKaupallinenViivästyskorkoProsentti(this.dateService.currentLocalDate())
    } catch (err) {
      return 9.5
    }
  }

  annaViivastyskorkoProsentti(juurilasku: Lasku, kasiteltava: LaskuBase): Big {
    if (this.laskuSharedService.onkoUlkoinenLasku(juurilasku)) {
      if (kasiteltava.nrotyyppi === LaskunumeroTyyppi.TAVALLINEN) {
        return new Big(juurilasku.viivastyskorkoprosentti ?? 0)
      }
      if (kasiteltava.nrotyyppi === LaskunumeroTyyppi.HYVITYS || kasiteltava.nrotyyppi === LaskunumeroTyyppi.MUISTUTUS) {
        const korvaus = this.laskuSharedService.annaLiittyvaLaskuAvaimella(juurilasku, kasiteltava.avain)
        if (korvaus?.ulkoinenLaskuHyvitysTaiMuistutus?.viivastyskorkoprosentti !== undefined && korvaus?.ulkoinenLaskuHyvitysTaiMuistutus?.viivastyskorkoprosentti !== null) {
          return new Big(korvaus.ulkoinenLaskuHyvitysTaiMuistutus.viivastyskorkoprosentti)
        }
      }
    }

    return new Big(juurilasku.viivastyskorkoprosentti ?? 0)
  }

  laskeKorkoLaskulle(juurilasku: Lasku, kasiteltava: LaskuBase, asetukset: Laskuasetukset, reskontra: LaskuReskontra[]): number {
    const viivastyskorkoprosentti = this.annaViivastyskorkoProsentti(juurilasku, kasiteltava)
    const korko = this.laskeKorkoProsentilla(viivastyskorkoprosentti, reskontra, new Big(kasiteltava.summa), juurilasku.erapvm.toDate(), new Date())
    return this.currencyService.muutaBigDecimalRahaksi(korko)
  }

  // laskeKorko(reskontra: LaskuReskontra[], laskunSumma: Big, erapvm: Date, viivastyskorkoprosentti: Big, nyt: Date): Big {
  //   return this.laskeKorkoProsentilla(viivastyskorkoprosentti, reskontra, laskunSumma, erapvm, nyt)
  // }

  laskeKorkoProsentilla(viivastyskorkoprosentti: Big, reskontra: LaskuReskontra[], laskunSumma: Big, erapvm: Date, nyt: Date): Big {
    if (viivastyskorkoprosentti.eq(0)) {
      return new Big('0')
    }

    const prosentti = viivastyskorkoprosentti.div(new Big('100'))
    const paivia = new Big('365')
    // const paiviaKarkausVuosi = new Big('366') // TODO: jos päivän, jonka korkoa lasketaan, vuosi on karkausvuosi, tulisi jakaa tällä.
    const korkoOnJuossutPaivaa = this.dateService.paiviaValissa(nyt, erapvm)
    // console.log('nyt', this.dateService.dateToLocalDate(nyt), 'erapvm', this.dateService.dateToLocalDate(erapvm), 'paivia valissa', korkoOnJuossutPaivaa)

    // console.log('korkoOnJuossutPaivaa', korkoOnJuossutPaivaa)
    let korko = new Big('0')
    for (let i = 1; i < korkoOnJuossutPaivaa + 1; i++) {
      const kasiteltavaPaiva = this.dateService.lisaaPaivia(erapvm, i)
      const avoinna = laskunSumma.minus(this.reskontraService.annaReskontranSummaPaivalle(reskontra, kasiteltavaPaiva))
      // console.log(kasiteltavaPaiva, 'avoinna', avoinna.toFixed(6))
      const paivanKorko = prosentti.times(avoinna).div(paivia)
      korko = korko.plus(paivanKorko)
    }

    return korko
  }
}
